module.exports = __webpack_public_path__ + "1b503ad43f39317809dde5983121ea1f.svg";